module.exports = __webpack_public_path__ + "img/logo_login.f15d2ecb.png";